import gql from 'graphql-tag';
/*
* NOTE: This is a bodge to work around the ticketId-only API of the ticket approval panel and
* friends. We need to grab state off a ticket to hide/show the review button, but only the job
* approval panel has this information.
*
* Rather than calculate it and pollute props, This approach just "bodges" the needed data on where
* it is needed to help contain it.
*
* At a deeper level, I think this highlights something missing in the API between job approval and
* ticket approval. For now I think this is acceptable.
 */

/*
 * NOTE: Need to refetch this query after uploading a new ticket image
 */
export const TicketStatusQuery = gql`
  query TicketStatus($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      id
      hasTimeEntries: has_time_entries
      state
      job {
        id
        mutable
      }
      ticketNumber: ticket_number {
        id
        documentId: document_id
      }
    }
  }
`;
